import { render, staticRenderFns } from "./KYCListing.vue?vue&type=template&id=0ab5e23e&scoped=true&"
import script from "./KYCListing.vue?vue&type=script&lang=js&"
export * from "./KYCListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab5e23e",
  null
  
)

export default component.exports